/** Combine a YYYY-MM-DD date and HH:mm time (VN local) into a wall-clock-as-UTC ISO string. */
export function buildOneOffStartAt(date: string, time: string): string {
  return `${date}T${time}:00Z`;
}
